import { z } from 'zod'

export const AppealsStatusSchema = z.number().transform((val) => {
  switch (val) {
    case 0:
      return 'Pending Review'

    case 1:
      return 'Under Review' as const
    case 2:
      return 'Awaiting Documentation' as const
    case 3:
      return 'Approved' as const
    case 4:
      return 'Denied' as const
    case 5:
      return 'Resolved' as const
    case 6:
      return 'Incomplete' as const
    case 7:
      return 'Withdraw' as const
    case 8:
      return 'Escalated' as const
    case 9:
      return 'Closed' as const
    case 11:
      return 'Appeal In Review' as const
    // These status codes have a specific meaning in the backend.  (10, 12, 13)
    // They are for internal use only and we don't want to expose what they mean to the access users.
    // If you are unsure what to do with these, please reach out to Pontus or the backend team.
    case 10:
      return 'Awaiting Decision' as const
    case 12:
      return 'Awaiting Decision' as const
    case 13:
      return 'Awaiting Decision' as const
    default:
      throw new Error(`Invalid appeal status code: ${val}`)
  }
})

// Schema for individual appeal record
export const AppealSchema = z.object({
  id: z.number(),
  type: z.number(),
  type_code: z.string().nullable(),
  date_filed: z.string(),
  case_number: z.number(),
  student_id: z.number().nullable(),
  name: z.string().nullable(),
  reason: z.string(),
  status: AppealsStatusSchema,
  date_resolved: z.string().nullable(),
  days_in_appeal: z.number(),
})

// Schema for pagination links
const LinkSchema = z.object({
  url: z.string().nullable(),
  label: z.string(),
  active: z.boolean(),
})

// Main schema for the entire response
export const AppealsHistorySchema = z.object({
  current_page: z.number(),
  data: z.array(AppealSchema),
  first_page_url: z.string(),
  from: z.number(),
  last_page: z.number(),
  last_page_url: z.string(),
  links: z.array(LinkSchema),
  next_page_url: z.string().nullable(),
  path: z.string(),
  per_page: z.number(),
  prev_page_url: z.string().nullable(),
  to: z.number(),
  total: z.number(),
})

export type AppealsStatus = z.infer<typeof AppealsStatusSchema>
export type AppealsHistory = z.infer<typeof AppealsHistorySchema>
export type Appeal = z.infer<typeof AppealSchema>
